import { defaultProps, compose, withPropsOnChange } from 'recompose';
import { noop } from 'lodash';

export default compose(
  defaultProps({
    highlightColumnByIndex: noop,
  }),
  withPropsOnChange(['index'], ({ highlightColumnByIndex, index }) => ({
    highlightParentColumn: () => highlightColumnByIndex(index),
    unhighlightParentColumn: () => highlightColumnByIndex(null),
  })),
);
